// extracted by mini-css-extract-plugin
export var required = "_fg-0";